export function fmtTokens(n: number) {
  if (n >= 1e6) {
    return `${(n / 1e6).toFixed(1)}M`
  }
  if (n >= 1e3) {
    return `${(n / 1e3).toFixed(1)}K`
  }
  return `${n}`
}

export function fmtDuration(ms: number) {
  return `${(ms / 1000).toFixed(2)}s`
}

const rtf = new Intl.RelativeTimeFormat("en", { style: "narrow" })

export function fmtRelative(ms: number) {
  const diff = (ms - Date.now()) / 1000
  for (const [unit, divisor, limit] of [
    ["second", 1, 60],
    ["minute", 60, 3600],
    ["hour", 3600, 86400],
    ["day", 86400, 86400 * 30],
  ] as const) {
    if (Math.abs(diff) < limit) {
      return rtf.format(Math.round(diff / divisor), unit)
    }
  }
  return new Date(ms).toLocaleDateString()
}
